import { OnboardingScreenSocial } from '@/pages/Onboarding/Layouts/OwnAIMan_SPaN/screens/Social';

import { ScreenInteraction } from '../OwnAI/screens/Interaction';
import { ScreenName } from '../OwnAI/screens/Name';
import { ScreenPersonality } from '../OwnAI/screens/Personality';
import { ScreenSecurity } from '../OwnAI/screens/Security';
import { ScreenAboutLook } from '../OwnAIMan/screens/AboutLook';
import { ScreenAge } from '../OwnAIMan/screens/Age';
import { ScreenBodyShape } from '../OwnAIMan/screens/BodyShape';
import { BODY_SHAPE_OPTIONS } from '../OwnAIMan/screens/BodyShape/BODY_SHAPE_OPTIONS';
import { ScreenCommunicate } from '../OwnAIMan/screens/Communicate';
import { ScreenEmail } from '../OwnAIMan/screens/Email';
import { ScreenEthnicity } from '../OwnAIMan/screens/Ethnicity';
import { ScreenFindAi } from '../OwnAIMan/screens/FindAi';
import { ScreenMajorTurnOff } from '../OwnAIMan/screens/MajorTurnOff';
import { ScreenObedience } from '../OwnAIMan/screens/Obedience';
import { ScreenSettingUpProfile } from '../OwnAIMan/screens/SettingUpProfile';

import { LayoutDataType } from './types';

export const layoutSteps = {
  age: {
    component: ScreenAge,
    images: [],
  },
  ethnicity: {
    component: ScreenEthnicity,
    images: [],
  },
  find_ai: {
    component: ScreenFindAi,
    images: [],
  },
  body_shape: {
    component: ScreenBodyShape,
    images: BODY_SHAPE_OPTIONS.map(
      (option) =>
        `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai-man/body_shape/${option.id}.png`,
    ),
  },
  about_look: {
    component: ScreenAboutLook,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai-man/bg-about-look.png',
    ],
  },
  interactions: {
    component: ScreenInteraction,
    images: [],
  },
  communicate: {
    component: ScreenCommunicate,
    images: [],
  },
  obedience: {
    component: ScreenObedience,
    images: [],
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  major_turn_off: {
    component: ScreenMajorTurnOff,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai-man/modal_send_photos.png',
    ],
  },
  security: {
    component: ScreenSecurity,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  social: {
    component: OnboardingScreenSocial,
    images: [],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  age: null,
  ethnicity: null,
  body_shape: null,
  interaction: null,
  communicate: null,
  obedience: null,
  personality: {
    shy_dominant: 50,
    serious_flirty: 50,
    logical_emotional: 50,
    affectionate_independent: 50,
  },
  major_turn_off: null,
  send_photos: null,
  name: '',
  characters: [],
  email: '',
};

// Category constants - not used, already hardcoded in AboutLook screen
export const HARDCODED_CATEGORIES = [];
